import { ChatBubble } from './types'

/** Hizalanan kullanıcı mesajının panelin üst kenarından bırakılan boşluğu (px). */
export const REPLY_ANCHOR_GAP_PX = 8

/**
 * Faz-44 (spec §7): canlı bir asistan yanıtı geldiğinde bayinin o yanıtı tetikleyen mesajı panelin
 * en üstüne hizalanır; yanıt onun altından başlar, devamını bayi kendisi kaydırır.
 *
 * Döner: hizalanacak kullanıcı balonunun id'si; `null` → bugünkü gibi en alta kaydır.
 * - "Yazıyor" göstergesi sürerken (`sending`) daima en alt: bayinin gönderdiği mesaj görünür kalır.
 * - Yalnız son balon bot yanıtı ve hemen öncesi bu oturumda canlı gönderilen kullanıcı mesajıysa
 *   (`liveReplyUserId`) hizalanır. Geçmiş yükleme / yeni sohbet yeni id'ler üretir, eşleşmez → en alt.
 */
export function replyScrollAnchorId(
  messages: ChatBubble[],
  sending: boolean,
  liveReplyUserId: number | null
): number | null {
  if (sending || liveReplyUserId === null || messages.length < 2) return null

  const last = messages[messages.length - 1]
  const previous = messages[messages.length - 2]
  if (last.role !== 'bot' || previous.role !== 'user' || previous.id !== liveReplyUserId) return null

  return previous.id
}

/** Kaydırma kabının içindeki `anchor` öğesini üstte `gap` boşlukla gösterecek `scrollTop` değeri. */
export function anchorScrollTop(body: HTMLElement, anchor: HTMLElement, gap = REPLY_ANCHOR_GAP_PX): number {
  const offset = anchor.getBoundingClientRect().top - body.getBoundingClientRect().top
  return Math.max(0, body.scrollTop + offset - gap)
}
